import { colors } from '@/theme/foundations';
import {
  TeamMembershipRole,
  TeamPurpose,
  TeamScope,
} from '@/types/teams';

export const TEAMS_PAGE_SIZE = 20;
export const TEAMS_STALE_TIME = 30_000;
export const TEAMS_GC_TIME = 5 * 60 * 1000;

export const TEAMS_QUERY_OPTIONS = {
  staleTime: TEAMS_STALE_TIME,
  gcTime: TEAMS_GC_TIME,
};

export const TEAMS_QUERY_KEY = 'teams';
export const TEAM_QUERY_KEY = 'team';

export const TEAM_PURPOSE_LABELS: Record<TeamPurpose, string> = {
  operations: 'Operations',
  project_management: 'Project Management',
  sales: 'Sales',
  account_management: 'Account Management',
  administrative: 'Administrative',
  custom: 'Custom',
};

export const TEAM_PURPOSE_COLORS: Record<TeamPurpose, string> = {
  operations: colors.alternative.blue,
  project_management: colors.alternative.purple,
  sales: colors.alternative.gold,
  account_management: colors.alternative.green,
  administrative: colors.gray[400],
  custom: colors.gray[300],
};

/** Soft purpose fills for cards/icon discs (not page header bands). */
export const TEAM_PURPOSE_WASHES: Record<TeamPurpose, string> = {
  operations: colors.alternative['blue-10'],
  project_management: colors.alternative['purple-10'],
  sales: colors.alternative['gold-10'],
  account_management: colors.alternative['green-10'],
  administrative: 'whiteAlpha.50',
  custom: 'whiteAlpha.50',
};

export const TEAM_SCOPE_LABELS: Record<TeamScope, string> = {
  active: 'Active',
  inactive: 'Archived',
  all: 'All',
};

export const TEAM_LIST_TABS: { label: string; value: TeamScope }[] = [
  { label: TEAM_SCOPE_LABELS.active, value: 'active' },
  { label: TEAM_SCOPE_LABELS.inactive, value: 'inactive' },
  { label: TEAM_SCOPE_LABELS.all, value: 'all' },
];

/** Suggested responsibility chips keyed by purpose. Custom chips still allowed. */
export const TEAM_RESPONSIBILITY_PRESETS: Record<TeamPurpose, string[]> = {
  operations: [
    'Dispatch',
    'SLA',
    'Engineer coverage',
    'Escalations',
    'First fix',
  ],
  project_management: [
    'Delivery',
    'Change control',
    'Programme reporting',
    'Workstreams',
  ],
  sales: ['Pipeline', 'Quotes', 'Account openings', 'Renewals'],
  account_management: [
    'Retention',
    'QBR',
    'Commercial',
    'Site ownership',
  ],
  administrative: ['Onboarding', 'Access', 'Compliance', 'Platform'],
  custom: [],
};

export const TEAM_MEMBERSHIP_ROLE_LABELS: Record<
  TeamMembershipRole,
  string
> = {
  team_lead: 'Team lead',
  manager: 'Manager',
  senior_member: 'Senior member',
  member: 'Member',
  observer: 'Observer',
};

export const TEAM_MANAGING_ROLES: TeamMembershipRole[] = [
  'team_lead',
  'manager',
];

export const TEAM_PURPOSES: TeamPurpose[] = [
  'operations',
  'project_management',
  'sales',
  'account_management',
  'administrative',
  'custom',
];
